exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".import-clients-dialog .title {\n  text-align: left;\n  padding-left: 0; }\n\n.import-clients-dialog .dropzone {\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  text-align: center; }\n  .import-clients-dialog .dropzone:hover {\n    cursor: pointer; }\n  .import-clients-dialog .dropzone:focus {\n    outline: none; }\n  .import-clients-dialog .dropzone.dropped {\n    border-color: #FF7800; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/clients/list/import/index.scss
// module id = 1194
// module chunks = 0